import { CrudState } from "@/store/Crud/State";
export class State extends CrudState {
  courseDataList: Array<any> = [];
  matchDataItem: Record<string, any> = {};
  booked: any = false;
}
